import { Nullable } from "utils/types/util.types";

export const isNotNull = <T>(object: Nullable<T>): object is T => object !== null && object !== undefined;
export const isNull = <T>(object: Nullable<T>): object is T => object === null || object === undefined;
export const isEmptyString = (object: any): object is "" => typeof object === "string" && object.trim() === "";
export const isArray = (object: any): object is any[] => Array.isArray(object);
